// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#2f184c","secondaryColor":"#b94860","lightBlue":"#e3e7ef","lightGrey":"#c3c3c3","div":"MenuItems_div__-m9Mz","avatar":"MenuItems_avatar__2uD3E"};